<template>
  <div :class="[over ? 'active-header' : '', 'header']" @mouseover="mouseover" @mouseout="mouseout">
    <div class="logo">
      <el-image style="width: 1080; height: 100%" :src="logo" fit="contain"></el-image>
    </div>
    <div class="title">
      <div v-for="(item, index) in headers" :key="index" class="menu-item">
        <a
          :class="active === item.name ? 'active button' : 'button'"
          @click="handleClickHeader(item)"
          @mouseover="handleMouseoverHeader(item)"
          @mouseout="handleMouseoutHeader"
        >
          {{ item.label }}
        </a>
      </div>
    </div>
    <div :class="[subMenu.length ? 'slider' : 'hide', 'submenu']" @mouseout="subMouseout" @mouseover="clearTime">
      <div
        :class="subActive === child.name ? 'active menu-item' : 'menu-item'"
        v-for="(child, index) in subMenu"
        :key="index"
        @mouseover="subMouseover(child)"
      >
        <a class="button" @click="handlePageChange(child.url)">
          {{ child.label }}
        </a>
      </div>
    </div>
    <div :class="[thirdMenu.length ? 'slider' : 'hide', 'thirdmenu']" @mouseout="thirdMouseout" @mouseover="clearTime">
      <div
        :class="thirdActive === child.name ? 'active menu-item' : 'menu-item'"
        v-for="(child, index) in thirdMenu"
        :key="index"
        @mouseover="thirdMouseover(child)"
      >
        <a class="button" @click="handlePageChange(child.url)">
          {{ child.label }}
        </a>
      </div>
    </div>
    <div class="menu" @click="showMenu = true">
      <i class="el-icon-menu"></i>
    </div>
    <div :class="{ showMenu, 'menu-box': true }">
      <div style="height: 40px"></div>
      <div
        style="
          text-align: right;
          margin-right: 30px;
          cursor: pointer;
          font-size: 20px;
          position: fixed;
          right: 0px;
          top: 10px;
        "
        @click="closeMenu"
      >
        <i class="el-icon-close"></i>
      </div>
      <div @click="handlePageChange('/')">主页</div>
      <div @click="toggleExpand('solution')">
        解决方案
        <i v-if="!expandedMenu.solution" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.solution" class="child">
        <div @click="handlePageChange('/microclimate')">微气候系统</div>
        <div @click="handlePageChange('/product/x2')">五恒系统</div>
        <div @click="handlePageChange('/product/x2')">水系统</div>
        <div @click="handlePageChange('/product/x2')">光系统</div>
        <div @click="handlePageChange('/product/x2')">声音系统</div>
      </div>
      <div @click="toggleExpand('product')">
        产品中心
        <i v-if="!expandedMenu.product" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.product" class="child">
        <div @click="handlePageChange('/product/x2')">AI模组</div>
        <div @click="handlePageChange('/product/x2')">执行器</div>
        <div @click="handlePageChange('/product/x2')">感知模组</div>
        <div @click="handlePageChange('/product/x2')">控制器</div>
        <div @click="handlePageChange('/product/x2')">隐形风口踢脚线</div>
        <div @click="handlePageChange('/product/x2')">智能排风扇</div>
      </div>
      <div @click="toggleExpand('custom')">
        定制服务
        <i v-if="!expandedMenu.custom" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.custom" class="child">
        <div @click="handlePageChange('/product/x2')">AI空间方案设计</div>
        <div @click="handlePageChange('/product/x2')">空间机械结构</div>
        <div @click="handlePageChange('/product/x2')">软件开发</div>
        <div @click="handlePageChange('/product/x2')">硬件开发</div>
        <div @click="handlePageChange('/product/x2')">气味艺术空间</div>
      </div>
      <div @click="toggleExpand('Core')">
        核心技术
        <i v-if="!expandedMenu.Core" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.Core" class="child">
        <div @click="handlePageChange('/product/x2')">AI感知</div>
        <div @click="handlePageChange('/product/x2')">无面板多控制模式</div>
      </div>
      <div @click="toggleExpand('Case')">
        项目案例
        <i v-if="!expandedMenu.Case" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.Case" class="child">
        <div @click="handlePageChange('#')">工程案例</div>
        <div @click="handlePageChange('#')">零售项目</div>
      </div>
      <div @click="toggleExpand('Cooperation')">
        生态合作
        <i v-if="!expandedMenu.Cooperation" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.Cooperation" class="child">
        <div @click="handlePageChange('/product/x2')">行业合作</div>
        <div @click="handlePageChange('/product/x2')">城市合伙人加盟</div>
        <div @click="handlePageChange('/product/x2')">体验中心</div>
        <div @click="handlePageChange('/product/x2')">好窝服务</div>
      </div>
      <div @click="toggleExpand('News')">
        新闻中心
        <i v-if="!expandedMenu.News" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.News" class="child">
        <div @click="handlePageChange('/news/0')">公司新闻</div>
        <div @click="handlePageChange('/news/1')">行业新闻</div>
        <div @click="handlePageChange('/news/2')">学习干货</div>
      </div>
      <div @click="toggleExpand('About')">
        关于我们
        <i v-if="!expandedMenu.About" class="el-icon-caret-bottom" style="margin-left: 6px"></i>
        <i v-else class="el-icon-caret-top" style="margin-left: 6px"></i>
      </div>
      <div v-if="expandedMenu.About" class="child">
        <div @click="handlePageChange('/about')">关于我们</div>
        <div @click="handlePageChange('/JoinUs')">加入我们</div>
        <div @click="handlePageChange('#')">共创</div>
        <div @click="handlePageChange('#')">用户社区</div>
        <div @click="handlePageChange('#')">用户口碑</div>
      </div>
      <div @click="handlePageChangee('/')">预约体验</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',

  data() {
    return {
      expandedMenu: {
        solution: false,
        product: false,
        custom: false,
        Core: false,
        Case: false,
        Cooperation: false,
        News: false,
        About: false,
      },
      subMenu: [],
      clientWidth: 0,
      showMenu: false,
      over: false,
      active: '',
      timer: null,
      thirdMenu: [],
      thirdActive: '',
      headers: [
        {
          label: '首页',
          name: 'Home',
          url: '/',
          children: [],
        },
        {
          label: '解决方案',
          name: 'Solution',
          children: [
            { label: '微气候系统', name: 'microclimate', url: '/Microclimate' },
            { label: '五恒系统', name: 'Keep', url: '/Keep' },
            { label: '水系统', name: 'Water', url: '/Water' },
            { label: '光系统', name: 'Light', url: '/Light' },
            { label: '声音系统', name: 'Voice', url: '/product/x2' },
          ],
        },
        {
          label: '产品中心',
          name: 'Product',
          children: [
            { label: 'AI模组', name: 'Module', url: '/product/x2' },
            { label: '执行器', name: 'Actuator', url: '/product/x2' },
            { label: '感知模组', name: 'Perception', url: '/product/x2' },
            { label: '控制器', name: 'Controller', url: '/product/x2' },
            { label: '隐形风口踢脚线', name: 'Skirting', url: '/product/x2' },
            { label: '智能排风扇', name: 'Exhaust', url: '/product/x2' },
          ],
        },
        {
          label: '定制服务',
          name: 'Custom',
          children: [
            { label: 'AI空间方案设计', name: 'Ai', url: '/product/x2' },
            { label: '空间机械结构', name: 'Structure', url: '/product/x2' },
            { label: '软件开发', name: 'Software', url: '/product/x2' },
            { label: '硬件开发', name: 'Hardware', url: '/product/x2' },
            { label: '气味艺术空间', name: 'Space', url: '/product/x2' },
          ],
        },
        {
          label: '核心技术',
          name: 'Core',
          children: [
            { label: 'AI感知', name: 'Perception', url: '/product/x2' },
            { label: '无面板多控制模式', name: 'Control', url: '/product/x2' },
          ],
        },
        {
          label: '项目案例',
          name: 'Case',
          children: [
            {
              label: '工程案例',
              children: [
                { label: '商业项目', name: 'Commercial', url: '/Commercial' },
                { label: '住宅项目', name: 'Residence', url: '/Residence' },

                // { label: '地产项目', name: 'Realty', url: '#' },
                // { label: '酒店项目', name: 'Hotel', url: '#' },
                // { label: '商业项目', name: 'Commerce', url: '#' },
                // { label: '项目应用领域', name: 'Use', url: '#' },
                // { label: '项目合作伙伴', name: 'Partner', url: '#' },
              ],
            },
            {
              label: '零售项目',
              children: [
                { label: '北京', name: 'BeiJing', url: '#' },
                { label: '上海', name: 'ShangHai', url: '#' },
                { label: '广州', name: 'GuangZhou', url: '#' },
                { label: '深圳', name: 'ShenZhen', url: '#' },
                { label: '香港', name: 'HongKong', url: '#' },
                { label: '杭州', name: 'HangZhou', url: '#' },
                { label: '苏州', name: 'SuZhou  ', url: '#' },
                { label: '成都', name: 'ChengDu', url: '#' },
                { label: '武汉', name: 'WuHan', url: '#' },
                { label: '宁波', name: 'NingBo', url: '#' },
                { label: '哈尔滨', name: 'HaErBin', url: '#' },
                { label: '长春', name: 'ChangChun', url: '#' },
                { label: '沈阳', name: 'ShenYang', url: '#' },
              ],
            },
          ],
        },
        {
          label: '生态合作',
          name: 'Cooperation',
          url: '/Cooperation',
          children: [
            { label: '行业合作', name: 'Industry', url: '#' },
            { label: '城市合伙人加盟', name: 'CityPartner', url: '#' },
            { label: '体验中心', name: 'Exploration', url: '#' },
            { label: '好窝服务', name: 'Serve', url: '#' },
          ],
        },
        {
          label: '新闻中心',
          name: 'News',
          url: '/news/0',
          children: [
            { label: '公司新闻', name: 'Company', url: '/news/0' },
            { label: '行业新闻', name: 'Business', url: '/news/1' },
            { label: '学习干货', name: 'Learning', url: '/news/2' },
          ],
        },
        {
          label: '关于我们',
          name: 'About',
          children: [
            {
              label: '共创',
              children: [{ label: '用户口碑', name: 'Evaluate', url: '#' }],
            },
            {
              label: '成长',
              children: [
                { label: '关于我们', name: 'AboutUs', url: '/About' },
                { label: '加入我们', name: 'JoinUs', url: '/JoinUs' },
              ],
            },
            {
              label: '帮助',
              children: [{ label: '解决方案对比', name: 'Evaluate', url: '/SolutioCompare' }],
            },
          ],
        },
        { label: '预约体验', name: 'Experience', url: '/Experience' },
      ],
      subActive: false,
      logo: require('@/assets/images/logo.jpg'),
      expandPro: false,
    }
  },

  methods: {
    thirdMouseover(child) {
      this.thirdActive = child.name
    },
    clearTime() {
      clearTimeout(this.timer)
      this.timer = null
    },
    thirdMouseout() {
      this.timer = setTimeout(() => {
        this.subMenu = []
        this.active = ''
        this.subActive = ''
        this.thirdActive = ''
        this.thirdMenu = []
      }, 300)
    },
    subMouseout() {
      this.timer = setTimeout(() => {
        this.subMenu = []
      }, 300)
    },
    subMouseover(child) {
      clearTimeout(this.timer)
      this.subActive = child.name
      this.thirdMenu = child.children || []
      this.over = true
      this.timer = null
    },
    handleMouseoutHeader() {
      this.timer = setTimeout(() => {
        this.active = ''
        this.subMenu = []
      }, 300)
    },
    handleMouseoverHeader(item) {
      clearTimeout(this.timer)
      this.timer = null
      this.over = true
      this.active = item.name
      this.thirdMenu = []
      this.thirdActive = ''
      this.subMenu = item.children ? item.children : []
    },
    mouseover() {
      document.querySelector('.header').classList.add('active-header')
    },
    mouseout() {
      if (!this.isScrolling) {
        document.querySelector('.header').classList.remove('active-header')
      }
    },
    handleScroll() {
      this.isScrolling = window.scrollY > 0
      if (this.isScrolling) {
        document.querySelector('.header').classList.add('active-header')
      } else {
        document.querySelector('.header').classList.remove('active-header')
      }
    },
    handleClickHeader(item) {
      if (item.url) {
        this.$router.push(item.url)
      } else if (item.children && item.children.length) {
        this.subMenu = item.children
      }
    },
    closeMenu() {
      this.showMenu = false
    },
    handlePageChange(page) {
      // 如果当前路径已经是目标路径，则不进行导航
      if (this.$route.path === page) {
        return
      }
      // 关闭菜单并进行路由跳转
      this.closeMenu()
      this.$router.push(page)
    },
    toggleExpand(menu) {
      if (this.expandedMenu[menu]) {
        this.expandedMenu[menu] = false // 折叠当前菜单
      } else {
        // 关闭所有其他菜单
        Object.keys(this.expandedMenu).forEach(key => {
          this.expandedMenu[key] = false
        })
        this.expandedMenu[menu] = true // 展开当前菜单
      }
    },
  },
}
</script>

<style scoped>
.submenu {
  width: 100%;
  position: absolute;
  top: 80px;
  height: 0;
  left: 0;
  overflow: hidden;
  transition: height 0.3s ease 0.4s;
  text-align: center;
  background: rgba(66, 66, 66, 0.95);

  &.slider {
    height: 60px;
    line-height: 60px;
    transition: height 0.3s ease;
  }
  .menu-item {
    display: inline-block;
    padding: 0 10px;
    margin: 0 10px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    color: #fff;
  }
  .menu-item .button {
    padding-bottom: 8px;
  }
  .menu-item .button:hover {
    border-bottom: 1px solid #fff;
  }
}
.thirdmenu {
  width: 100%;
  position: absolute;
  top: 140px;
  height: 0;
  left: 0;
  overflow: hidden;
  transition: height 0.3s;
  text-align: center;
  background: rgba(66, 66, 66, 0.9);

  &.slider {
    height: 60px;
    line-height: 60px;
    transition: height 0.3s ease;
  }
  .menu-item {
    display: inline-block;
    padding: 0 10px;
    margin: 0 10px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    color: #fff;
  }
  .menu-item .button {
    padding-bottom: 8px;
  }
  .menu-item .button:hover {
    border-bottom: 1px solid #fff;
  }
}
@media screen and (max-width: 768px) {
  .header {
    display: flex !important;
    justify-content: space-between !important;
    z-index: 999 !important;
    padding: 0 5% !important;
    height: 70px !important;
    line-height: 70px !important;
    .logo {
      width: 140px !important;
    }

    .title {
      display: none !important;
      div {
        width: auto !important;
        margin-left: 4px !important;
      }
    }

    .menu {
      font-size: 28px !important;
      color: #fff !important;
      cursor: pointer !important;
      display: block !important;
    }
  }
}
@media screen and (min-width: 950px) {
  .logo {
    .el-image {
      width: 180px !important;
    }
  }
}
@media screen and (max-width: 950px) {
  .title {
    div {
      width: auto !important;
      margin-left: 4px !important;
    }
  }
}

.header {
  box-sizing: border-box;
  position: fixed;
  height: 80px;
  line-height: 80px;
  top: 0;
  width: 100vw;
  background: rgba(0, 0, 0, 0); /* 默认菜单栏背景色 */
  transition: all 0.3s ease 0.5s;
}
.header.active-header {
  transition: all 0.3s ease;
  background: rgba(44, 44, 44, 1); /* 鼠标移入和页面下滑时的背景色 */
}
@media screen and (max-width: 850px) {
  .title {
    font-size: 12px !important;
    div {
      font-size: 12px !important;
    }
  }
}

@media screen and (min-width: 768px) {
  .header {
    display: flex;
    justify-content: space-around;
    z-index: 999;
    padding: 0 0 0 2.5%;
    .logo {
      width: 10vw;
    }

    .title {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      padding-right: 15px;

      div {
        text-align: center;
        width: 8vw;
        white-space: nowrap;

        .button {
          height: 40px;
          color: #fff;
          padding: 4px 12px;
          cursor: pointer;
          outline: none;
          position: relative;
        }
        .button:after {
          content: '';
          display: block;
          bottom: -8px;
          height: 1px;
          position: absolute;
          width: 0;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(255, 255, 255, 0);
          transition: all 0.3s ease;
        }
        .active:after {
          width: 80px;
          background: rgba(255, 255, 255, 1);
          transition: all 0.3s ease;
        }
      }
    }

    .menu {
      display: none;
    }
  }
}

.menu-box {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: #fff;
  text-align: center;
  padding-bottom: 30px;
  display: none;
  font-weight: 600;
  background: rgba(68, 68, 68, 0.92);
  div {
    line-height: 60px;
  }
}

.showMenu {
  overflow-y: auto;
  max-height: 70vh;
  display: block;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(0, 142, 214, 0.2);
  color: #008ed6;
}

.child {
  color: #fff;
  font-size: 15px;
  font-weight: normal;
  background-color: rgba(37, 37, 37, 0.7);
}

.img {
  background: transparent !important;
}

.holder {
  height: 80px;
  width: 100vw;
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0;
}
</style>
